import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../layout/BreadCrumb";
import ProjectDetails from "./ProjectDetails";
import CardLoading from "../../../../components/CardLoading";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Table } from "antd";
import svg14 from "../../../../assets/svg/svg14.svg";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { cashConverter, formatText } from "../../../../utils";
import { setActiveObj } from "../../../../features/obj/objSlice";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import ConfirmModal from "../../../../components/ConfirmModal";

function ExpressionIspList() {
  const url = "api/v2/flid/projects/getProjectBids";
  const { saving } = useSelector((state) => state.save);
  const { loading, data, count, activeObjexpressions } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjexpressions: state.obj.activeObj["expressions"],
    })
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd, setProdd] = useState("");

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = async () => {
    const allActive = data?.every(
      (bid) =>
        bid?.projectBidStatus === "PUBLISHED_AND_ACCEPTED" ||
        bid?.projectBidStatus === "REJECTED"
    );

    if (!allActive) {
      toast.error(
        "This action is not possible. Kindly make sure all the bids are accepted by the ISP or rejected to proceed"
      );
      return;
    }
    await setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleView = async (item) => {
    await dispatch(setActiveObj({ key: "expressionIsp", data: item }));
    navigate("/expression-view");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "expressionIsp", data: item }));
    navigate("/expression-view");
  };
  const handlePublish = async () => {
    const res = await dispatch(
      save({
        projectId: activeObjexpressions?.projectId,
        url: "api/v2/flid/projects/publishBidsToFarmer",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchProjectBiddersData()
      await setOpenDelete(false);
    } else {
      toast.error(res?.payload?.message);
    }
  };
  const columns = [
    {
      title: "Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.microIrrigationPartnerName}
          </div>
        );
      },
      sorter: (a, b) =>
        a.microIrrigationPartnerName.localeCompare(
          b.microIrrigationPartnerName
        ),
    },
    {
      title: "Installed Projects",
      dataIndex: "projectCount",
      sorter: (a, b) => a.projectCount - b.projectCount,
    },
    {
      title: "Estimated Cost",
      dataIndex: "estimatedCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.estimatedCost - b.estimatedCost,
    },
    {
      title: "Status",
      dataIndex: "projectBidStatus",
      render: (item) => {
        const colors = {
          ON_SURVEY: "#E1D77C",
          SUBMITTED_FOR_STANDARDIZATION: "#7DACDC",
          PUBLISHED: "#B1E17C",
          PUBLISHED_AND_ACCEPTED: "#E1D77C",
          PENDING_FARMER: "#F4FBF7",
          ACCEPTED: "#B1E17C",
          REJECTED: "#A40909", 
        };

        return (
          <div
            className={`${item === 'PENDING_FARMER' ? 'text-black' : 'text-[#FFF]'}  inline-block rounded-[.5rem] px-[.5rem] py-[.25rem] w-auto`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleView(item)}>
            <img src={svg14} alt="svg14" />
          </button>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchProjectBiddersData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        projectId: activeObjexpressions?.projectId,
        projectName: null,
        projectStatus: null,
        ipId: null,
        projectBidId: null,
      })
    );
  }

  useEffect(() => {
    fetchProjectBiddersData();
  }, []);

  if (loading) return <CardLoading />;
  const btnInactive = data?.every(
    (bid) => bid?.projectBidStatus === "PENDING_FARMER"
  );

  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "back" },
          // { title: "Expressions List", path: "back" },
          { title: "Expressions List", path: "/expression-of-interest" },
          { title: "Expression ISP List" },
        ]}
      />

      <ProjectDetails />
      <div className="mt-[1.25rem] white_card">
        <div className="flex items-center justify-between">
          <div className="graph_h1">MISPS Bid List</div>
          <div className="w-[200px]">
            {activeObjexpressions?.projectStatus == "SUBMITTED" ? (
              <button onClick={() => handleOpenDelete()} className="cstm-btn-2">
                <span className="">Publish to Farmer</span>
              </button>
            ) : null}
          </div>
        </div>

        <div>
          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.custId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchProjectBiddersData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handlePublish}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="info"
        btnTitle="Publish"
      />
    </div>
  );
}

export default ExpressionIspList;
